// aws-sdk requires global to exist
declare global {
    interface Window {
        global?: typeof globalThis;
    }
}

window.global = window;

export {};
